export const newProjectInsideAlice = {
  data() {
    return {
      tourOptions: {
        id: 2,
        highlight: true,
        useKeyboardNavigation: true,

        labels: {
          buttonSkip: "Закончить",
          buttonPrevious: "Назад",
          buttonNext: "Далее",
          buttonStop: "ОК",
        },
      },
      tourStep: 0,
      steps: [
        {
          target: "#in-step-0", // We're using document.querySelector() under the hood
          content: `Сейчас Вы работаете в режиме интерактивного обучения. Вы в любое время можете запустить его заново, просто нажав на эту кнопку.`,
        },
        {
          target: ".in-step-1",
          content: "Настройки проекта.",
        },
        {
          target: ".in-step-1_1",
          content: "Настройки отчета.",
        },
        {
          target: ".in-step-2",
          content:
            "Описание объекта защиты. В этой области можно добавить описание проекта, которое в дальнейшем будет добавлено в отчет по результатам расчета.",
        },
        {
          target: ".in-step-3",
          content:
            "Дополнительные мероприятия. В случае если после расчета значение величины риска превышено, возможно выбрать одно из мероприятий, установленных Федеральным законом № 123-ФЗ",
        },
        {
          target: "#in-step-4",
          content:
            "Редактор городов. Редактор городов предназначен для того случая, когда необходимый город для проекта отсутствует в списке. По умолчанию, в списке содержатся города в соответствии со СНиП 2.01.01-82. «Строительная климатология и геофизика»",
        },
        {
          target: "#in-step-5",
          content:
            "Редактор веществ. Редактор веществ предназначен для создания/корректировки веществ (жидкости, СУГ/СПГ, газы). С помощью редактора можно выбрать необходимое вещество, посмотреть его свойства и при необходимости изменить. Также возможно добавить необходимое вещество, если его не оказалось в списке.",
        },
        {
          target: "#in-step-6",
          content:
            "В программе предусмотрено 5 компонентов . Для добавления компонента нужно выбрать необходимую вкладку и нажать кнопку добавления. <strong>Не забудьте</strong> нанести объект на подложку, для этого просто перетащите его в нужную область.",
        },
        {
          target: "#in-step-7",
          content: "В этой области находятся элементы для работы с картой.",
        },
        {
          target: "#in-step-8",
          content: "Загрузка подложки. Вы можете загрузить любое изображение.",
        },
        {
          target: "#in-step-9",
          content:
            "Загрузка участка карты. Вы можете выбрать область карты, чтобы использовать ее вместо подложки. <strong>Масштаб</strong> будет задан автоматически.",
        },
        {
          target: "#in-step-10",
          content:
            "Задание масштаба. Отметьте 2 точки и укажите реальное расстояние между ними в метрах, после чего программа автоматически расчитает масштаб.",
        },
        {
          target: "#in-step-11",
          content: "Измерение расстояния. Отметьте 2 точки, программа выведет расстояние между ними в метрах.",
        },
        {
          target: "#in-step-12",
          content:
            "Определение величины потенциального риска на карте. После нажатия на кнопку переместите курсор в необходимое место измерения и нажмите левой кнопкой мыши. Значение отобразится автоматически.",
        },
        {
          target: "#in-step-13",
          content:
            "Для визуальной оценки полученных результатов в интерфейсе предусмотрена шкала потенциального риска. После выполнения расчета в основной области проекта отобразится карта полей рисков. Цветовые значения на карте соответствуют цветовым значениям на шкале.",
        },
        {
          target: "#in-step-14",
          content: "Слои. Вы можете выбрать какую информацию следует отображать на карте.",
        },
        {
          target: ".in-step-15",
          content:
            "Основные результаты расчета рисков по проекту обобщаются в таблице результатов. Значения в таблице обновляются автоматически, по мере наличия исходных данных. Зеленым цветом выделяются значения, соответствующие требованиям нормативных документов, красным – не соответствующие. Если в ячейке таблицы стоит значение 0, это значит данных для расчета либо недостаточно, либо риск не рассчитан.",
        },
        {
          target: ".in-step-16",
          content:
            "Запуск расчета. Если в проекте присутствуют ошибки или недостаточно данных для расчета, здесь будет информация о возникших проблемах. Если ошибок нет и информации достаточно, кнопка станет зеленой, и можно будет выполнить расчет.",
        },
      ],
      tourCallbacks: {
        onStop: this.tourStop,
        onNextStep: this.playNextAudio,
        onPreviousStep: this.playPrevAudio,
        onStart: this.playFirstAudio,
      },
      audio: null,
    };
  },
  mounted() {
    if (!this.$auth.user().helpStory.find((el) => el == this.tourOptions.id)) {
      this.$tours["newProjInsideTour"].start();
    }
  },

  methods: {
    playFirstAudio() {
      if (this.audio) {
        this.audio.pause();
      }
      this.audio = new Audio("/sound/newProjInside/0.mp3"); // path to file
      this.audio.play();
      var vm = this;
      this.audio.onended = function () {
        vm.$tours["newProjInsideTour"].nextStep();
      };
    },
    playPrevAudio(currentStep) {
      this.tourStep = currentStep - 1;
      this.audio.pause();
      this.audio = new Audio("/sound/newProjInside/" + (currentStep - 1) + ".mp3"); // path to file
      this.audio.play();
    },
    playNextAudio(currentStep) {
      this.tourStep = currentStep + 1;
      this.audio.pause();
      this.audio = new Audio("/sound/newProjInside/" + (currentStep + 1) + ".mp3"); // path to file
      this.audio.play();
      var vm = this;
      this.audio.onended = function () {
        if (currentStep == 16) {
          vm.$tours["newProjInsideTour"].stop();
        } else {
          vm.$tours["newProjInsideTour"].nextStep();
        }
      };
    },
    tourStop() {
      if (this.audio) {
        this.audio.pause();
      }
      if (!this.$auth.user().helpStory.find((el) => el == this.tourOptions.id)) {
        this.$http
          .get("profile/finish-help", {
            params: {
              id: this.tourOptions.id,
            },
          })
          .then((response) => {
            this.$auth.user().helpStory.push(response.data);
          });
      }
    },
    tourStart() {
      this.$tours["newProjInsideTour"].start();
    },
  },
};
